<template>
  <div id="resimEkle">
    <DraggableResim @change="imagesChange" :list="images" />
    <div class="resim-ekle-container">
      <input
        id="resimEkleInput"
        class="d-none"
        ref="file"
        type="file"
        @change="imageEkle"
        multiple
        accept="image/x-png, image/gif, image/jpeg, image/webP"
      />
      <div class="d-flex justify-center">
        <v-btn small :style="buttonstyle" id="resimEkleBtn" class="px-0">
          <label for="resimEkleInput">
            <v-icon small left>mdi-plus-circle</v-icon>{{$t('URUNLER.PRODUCT_IMAGE_OPERATIONS.ADD_IMAGE_BTN')}}
          </label>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import DraggableResim from "@/components/Modules/Urunler/DraggableResim.vue";
import _ from "lodash";

export default {
  name: "ResimEkle",
  props: {
    value: {
      type: Array
    },
    buttonstyle: {
      default: () => {}
    },
  },
  data() {
    return {
      images: []
    };
  },
  components: {
    DraggableResim
  },
  methods: {
    imageEkle(resimler) {
      let convertedImages = [],
        self = this,
        files = resimler.target.files;

      files.forEach(element => {
        convertedImages.push(this.convertToBase64(element));
      });

      return Promise.all(convertedImages)
        .then(b64Url => {
          b64Url.forEach((url, index) => {
            self.images.push({
              id: self.getLastID() + 1,
              name: files[index].name,
              url: url
            });
          });
        })
        .finally(() => {
          this.$refs.file.value = [];
        });
    },
    /**
     * Draggable list değiştiğinde
     */
    imagesChange(images) {
      this.images = images;
    },
    /**
     * Kayıtlı son id'yi al
     */
    getLastID() {
      if (this.images.length > 0)
        return _.sortBy(this.images, o => {
          return o.id;
        })[this.images.length - 1].id;
      else return 1;
    },
    convertToBase64(image) {
      return new Promise(resolve => {
        let picReader = new FileReader();
        picReader.onload = image => resolve(image.target.result);
        picReader.readAsDataURL(image);
      });
    }
  },
  watch: {
    value() {
      this.images = this.value;
    },
    images(images) {
      this.$emit("input", images);
    }
  }
};
</script>

<style>
#resimEkleBtn .v-btn__content {
  height: 100%;
}
#resimEkleBtn .v-btn__content label {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  padding: 0 25px;
}
</style>